//------------------------------------------------------------------------------
// Node Modules ----------------------------------------------------------------
import React from 'react';
import classNames from 'classnames';
//------------------------------------------------------------------------------
// Style -----------------------------------------------------------------------
import styles from './index.module.scss';
import { Trans, withTranslation } from 'react-i18next';
//------------------------------------------------------------------------------
// My Components ---------------------------------------------------------------
//------------------------------------------------------------------------------
// React Class -----------------------------------------------------------------
class QuestionSection extends React.Component {
  render() {
    const { t } = this.props;

    return (
      <div className={styles.Question}>
        <div className={styles.QuestionContent}>
          <h1 className={styles.Title}>{t('landing_QuestionSectionTitle')}</h1>

          <h2 className={styles.QuestionText}>{t('landing_TalkToYour')}</h2>
          <div className={styles.Contactinfo}>
            <h3 className={styles.ContactEmail}>{t('landing_Email')}</h3>
            <h3>{t('landing_Or')}</h3>
            <h3 className={styles.ContactPhone}>{t('landing_Phone')}.</h3>
          </div>
        </div>
      </div>
    );
  }
}
//------------------------------------------------------------------------------
// Export ----------------------------------------------------------------------
export default withTranslation()(QuestionSection);
